<template>
  <span>{{
      value && value.value ? value.value : value | percent(value && value.value ? value.noSign : noSign) | isNaN
    }}</span>
</template>

<script>
export default {
  name: "PercentageCell",
  props: {
    value: {},
    noSign: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style scoped>

</style>
